// import Bind from 'lodash-decorators/bind';
import React, {
  ChangeEvent,
  /*FormEvent, PureComponent,*/ useEffect,
  useRef,
  useState,
} from 'react';
import { connect, DispatchProp } from 'react-redux';
// import { ContentSection } from '../components/content/content_section';
// import { PageContent } from '../components/content/page_content';
// import { PageHeader } from '../components/content/page_header';
import { UpdatePasswordModal } from '../modals/update_password_modal';
import { RootState } from '../redux';
// import styled from '../theme';
import { updateCrispEmail, getCrispProfile } from '../api/crisp';
import { Crisp } from 'crisp-sdk-web';
// import { VContainer, VSpace } from '../components/UI/more_detail/container';
// import { FormSubtitle, PencilEdit, TrashDelete } from './account_settings';
// import { UserAvatar } from '../components/UI/avatar';
import { ValidationError } from '@quipa/api';
import { AvatarModal } from '../modals/avatar_modal';
import { getUser, handleUpdateUser, updateUsersPassword } from '../api/users';
import { uploadImage } from '../api/account';
import { Config } from '../utils';
import { validateEmail } from '../api/signup';
import { trackView } from '../components/analytics/track_view';
import { MixpanelEvents } from '../components/analytics/mix_panel_events';
import {
  /*ValidationForm,*/ FormValidationError,
} from '../ui_components/validation/validationForm';
// import FormField from '../ui_components/form/formField';
// import Button from '../ui_components/button/button';
import PageDimmer from '../ui_components/dimmer/PageDimmer';
// import {
//   ValidationPopupInput,
//   ValidationPopupStateInput,
//   ValidityMessagesMap,
// } from '../ui_components/validation/validationPopupInput';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { Switch } from '../components/ui/switch';
import { Button } from '../components/ui/button';
import { Trash2Icon, UploadIcon, UserIcon } from 'lucide-react';
import { ErrorInputPopUp } from '../components/input_popups/error_input_popup';
import { toast } from 'sonner';

export interface UserSettingsProps {
  email: string;
  firstName: string;
  lastName: string;
  accountId: number;
  logoId?: string | null;
  accountUser?: any;
  canAccessTeamSettings?: boolean;
  handleRefetchUser?(): void;
}

// const UserForm = styled(ValidationForm)`
//   max-width: 500px;
// `;

// const UpdatePasswordButton = styled(Button)`
//   margin-top: 1em;
//   color: white;
// `;
// const GrayBorder = styled.span`
//   padding: 11px 0 6px;
//   border: 1px solid #969696;
//   margin: 0 10px 0 15px;
// `;
// const AvatarContainer = styled.div`
//     flex: 1;
//    change: Api.UpdateUserAction[Req], undefined: undefined, undefined: undefined, undefined: undefined, p0: null, p1: null350px;
//     width: 100%;
//     margin-top: 12px;
// `;
// const AvatarActionContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   margin-top: 30px;
// `;
// interface State {
//   updatePasswordActive: boolean;
//   imageModalOpen: boolean;
//   logoId?: string | null;
//   validityMessages: ValidityMessagesMap<'password'>;
//   validityMessageOldPass: ValidityMessagesMap<'password'>;
//   validateError: boolean;
// }

// *** NEW FUNCTIONAL COMPONENT ***
// *** TYPES ***
type ValidityMessagesState = {
  password: {
    tooShort: string;
    patternMismatch: string;
  };
};
type ValidityMessageOldPassState = {
  password: {
    tooShort: string;
    patternMismatch: string;
  };
};
type FormState = {
  firstName: string;
  lastName: string;
  email: string;
  label: string;
};
type FormErrorState = {
  firstName: {
    active: boolean;
    message: string;
  };
  lastName: {
    active: boolean;
    message: string;
  };
  email: {
    active: boolean;
    message: string;
  };
  label: {
    active: boolean;
    message: string;
  };
};
// *** END OF TYPES ***
// *** INITIALS ***
const initialFormError = {
  firstName: {
    active: false,
    message: '',
  },
  lastName: {
    active: false,
    message: '',
  },
  email: {
    active: false,
    message: '',
  },
  label: {
    active: false,
    message: '',
  },
};

const parseJsonObject = (value: any): any => {
  if (typeof value !== 'string') {
    return value;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
};

const extractMessageFromPayload = (payload: any): string => {
  const normalizedPayload = parseJsonObject(payload);
  if (!normalizedPayload) {
    return '';
  }

  if (typeof normalizedPayload === 'string') {
    return normalizedPayload;
  }

  const directMessage = normalizedPayload?.message;
  if (typeof directMessage === 'string') {
    return directMessage;
  }
  if (directMessage && typeof directMessage?.message === 'string') {
    return directMessage.message;
  }

  if (normalizedPayload?.body) {
    const nestedMessage = extractMessageFromPayload(normalizedPayload.body);
    if (nestedMessage) {
      return nestedMessage;
    }
  }

  return '';
};

const extractApiErrorMessage = (error: any): string => {
  const fromResponse = extractMessageFromPayload(error?.response?.data);
  if (fromResponse) {
    return fromResponse;
  }
  return extractMessageFromPayload(error);
};

const extractApiResponseErrorMessage = (response: any): string => {
  if (!response) {
    return '';
  }

  if (response?.error === true) {
    return extractMessageFromPayload(response) || 'Request failed.';
  }

  const statusCode = Number(response?.statusCode);
  if (Number.isInteger(statusCode) && statusCode >= 400) {
    return extractMessageFromPayload(response) || 'Request failed.';
  }

  const bodyPayload = parseJsonObject(response?.body);
  if (bodyPayload?.error === true) {
    return extractMessageFromPayload(bodyPayload) || 'Request failed.';
  }

  return '';
};
// *** END OF INITIALS ***
export const UserSettingsPage = (props: UserSettingsProps & DispatchProp) => {
  // *** REFS ***
  const firstNameRef = useRef<HTMLInputElement | null>(null);
  const lastNameRef = useRef<HTMLInputElement | null>(null);
  const labelRef = useRef<HTMLInputElement | null>(null);
  const emailRef = useRef<HTMLInputElement | null>(null);
  // *** END OF REFS ***
  // *** STATES ***
  const [receiveEmails, setReceiveEmails] = useState<boolean>(
    props?.accountUser?.emailNotifications || false
  );
  const [form, setForm] = useState<FormState>({
    firstName: props?.accountUser?.firstName || props.firstName || '',
    lastName: props?.accountUser?.lastName || props.lastName || '',
    email: props?.accountUser?.email || props.email || '',
    label: props?.accountUser?.label || '',
  });
  const [formError, setFormError] = useState<FormErrorState>(initialFormError);
  const [updatePasswordActive, setUpdatePasswordActive] = useState<boolean>(false);
  const [imageModalOpen, setImageModalOpen] = useState<boolean>(false);
  const [logoId, setLogoId] = useState<any>(props.logoId);
  const [validateError, setValidateError] = useState<boolean>(false);
  const [validityMessages, setValidityMessages] = useState<ValidityMessagesState>({
    password: {
      tooShort: 'Must be at least 8 characters.',
      patternMismatch:
        'Must contain at least 8 characters including an uppercase letter, lowercase letter, and a number or special character..',
    },
  });
  const [validityMessageOldPass, setValidityMessageOldPass] = useState<ValidityMessageOldPassState>(
    {
      password: {
        tooShort: 'Must be at least 8 characters.',
        patternMismatch:
          'Must contain at least 8 characters including an uppercase letter, lowercase letter, and a number or special character..',
      },
    }
  );
  // *** END OF STATES***
  // *** FUNCTIONS ***
  const handleReceiveEmails = () => {
    setReceiveEmails((prev) => !prev);
  };
  const handleChangeFormError = (key: string, active: boolean, message: string) => {
    setFormError((prev) => ({ ...prev, [key]: { active: active, message: message } }));
  };
  const handleResetFormErrors = () => {
    setFormError(initialFormError);
  };
  const handleChangeForm = (e: ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;

    if (name === 'label') {
      if (value?.length > 10) return;

      value = value.trim();
      value = value.replace(/\s+/g, '')
    }

    setForm((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    setFormError((prev) => {
      return {
        ...prev,
        [name]: { active: false, message: '' },
      };
    });
  };
  const handleSetValidationMessage = (value: string): void => {
    setValidityMessages((prev) => {
      return {
        ...prev,
        password: {
          ...prev.password,
          patternMismatch: value,
        },
      };
    });
  };
  const handleSetValidationMessageOldPass = (value: string): void => {
    setValidityMessageOldPass((prev) => {
      return {
        ...prev,
        password: {
          ...prev.password,
          patternMismatch: value,
        },
      };
    });
  };

  const handleSetValidateError = (val: boolean): void => {
    setValidateError(val);
  };

  const deleteAvatarImage = async () => {
    const { accountId } = props;
    const user = localStorage.getItem('quipa-store');
    const email = user ? JSON.parse(user).user.email : '';
    const userUpdatePayload = {
      accountId,
      firstName: props.firstName,
      lastName: props.lastName,
      user: { email },
      logoId: null,
      email,
    };
    const res = await handleUpdateUser(userUpdatePayload);

    if (res.error) {
      if (res.payload.name === 'ValidationError') {
        const errors = (res.payload as Error as ValidationError).errors;
        throw FormValidationError.fromErrorDictionary(errors);
      } else {
        throw new Error(res.payload.message);
      }
    } else {
      localStorage.removeItem('logoId');

      window.location.reload();
    }
  };
  const saveAvatarImage = async (file: File) => {
    const { accountId } = props;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('accountId', accountId.toString());
    formData.append('fileStoreUrl', Config.fileStoreUrl);
    const res = await uploadImage(formData);

    if (res.error) {
      throw new Error(res.message);
    }
    const user = localStorage.getItem('quipa-store');
    const email = user ? JSON.parse(user).user.email : '';

    const userUpdatePayload = {
      accountId,
      logoId: res.url,
      user: { email },
    };

    const res1 = await handleUpdateUser(userUpdatePayload);

    if (res1.error) {
      if (res1.name === 'ValidationError') {
        const errors = (res1 as Error as ValidationError).errors;
        throw FormValidationError.fromErrorDictionary(errors);
      } else {
        throw new Error(res1.message);
      }
    } else {
      setLogoId(res.url);
      setImageModalOpen(false);
      localStorage.setItem('logoId', res.url || '');

      window.location.reload();
    }
  };

  const handleValidateFormOnBlur = (e: ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;
    setFormError((prev) => ({
      ...prev,
      [name]: { active: !value, message: !value ? 'Please fill out this field' : '' },
    }));
  };

  const handleValidateForm = () => {
    let validators = {
      firstName: (v: any) => {
        if (!v.trim()) return 'Please fill out this field';
        return '';
      },
      lastName: (v: any) => {
        if (!v.trim()) return 'Please fill out this field';
        return '';
      },
      label: (v: any) => {
        if (!props?.canAccessTeamSettings) return ''
        if (!v.trim()) return 'Please fill out this field';
        return '';
      },
      email: (v: any) => {
        if (!v.trim()) return 'Please fill out this field';
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v)) return 'Invalid email';
        return '';
      },
    };

    const nextErrors: any = {};

    for (const key of Object.keys(validators)) {
      const message = validators[key](form?.[key]);
      nextErrors[key] = { active: !!message, message: message };
    }

    setFormError((prev) => ({ ...prev, ...nextErrors }));
    return Object.values(nextErrors).every((err: any) => !err.active);
  };

  const submit = async (): Promise<void> => {
    // Validate form
    const validate = handleValidateForm();

    if (props.email !== form.email) {
      const unique_email = await validateEmail(form?.email?.trim());
      if (unique_email?.error) {
        let err_msg = 'An account with that Email already exists';
        let err_cond = true;
        let err_key = 'email';
        handleChangeFormError(err_key, err_cond, err_msg);
        console.error('Check the required fields.');
        return;
      }
    }
    if (!validate) {
      console.error('Check the required fields.');
      return;
    }
    // Reset errors
    handleResetFormErrors();

    const { firstName, lastName, accountId } = props;
    const user = localStorage.getItem('quipa-store');
    const email = user ? JSON.parse(user).user.email : '';
    /* tslint:disable:no-string-literal */
    // const newEmail = (e.currentTarget.elements['email'] as HTMLInputElement).value.trim();
    // const newFirstName = (e.currentTarget.elements['firstname'] as HTMLInputElement).value.trim();
    // const newLastName = (e.currentTarget.elements['lastname'] as HTMLInputElement).value.trim();
    const userSettingsPayload = {
      email: email !== form.email ? form.email : undefined,
      firstName: firstName !== form.firstName ? form.firstName : undefined,
      lastName: lastName !== form.lastName ? form.lastName : undefined,
      label: form.label,
      emailNotifications: receiveEmails,
    };

    const body = {
      ...userSettingsPayload,
      user: {
        email,
      },
      email: form.email ? form.email : email,
    };
    try {
      const res = await handleUpdateUser(body);
      const responseErrorMessage = extractApiResponseErrorMessage(res);
      if (responseErrorMessage) {
        toast.error(responseErrorMessage);
        return;
      }
      if (props.handleRefetchUser) {
        props.handleRefetchUser()
      }

      if (res && !res.email) {
        const user = localStorage.getItem('quipa-store');
        const token = user ? JSON.parse(user).user.token : '';

        let objectLocal: any = {
          user: { email: form.email ? form.email : email, token },
        };
        objectLocal = JSON.stringify(objectLocal);
        localStorage.setItem('quipa-store', objectLocal as string);
        localStorage.setItem('firstName', form.firstName);
        localStorage.setItem('lastName', form.lastName);
      }

      const accountPayload = {
        email: email !== form.email?.trim() ? form.email?.trim() : email,
        firstName: firstName !== form.firstName?.trim() ? form.firstName?.trim() : firstName,
        lastName: lastName !== form.lastName?.trim() ? form.lastName?.trim() : lastName,
        prevEmail: email,
      };
      let responseCrisp: any;
      try {
        responseCrisp = await updateCrispEmail(accountId, accountPayload);
      } catch (error) {
        responseCrisp = undefined;
      }

      if (responseCrisp?.status === 200) {
        const profile = await getCrispProfile(accountId);
        if (profile) {
          Crisp.user.setEmail(profile.email);
          Crisp.user.setNickname(`${profile.person.nickname}`);
        }
      }

      toast('Profile updated successfully');
      window.location.reload();
    } catch (error: any) {
      const apiMessage = extractApiErrorMessage(error);
      toast.error(apiMessage || 'Failed to update profile. Please try again later.');
    }
  };

  const openPasswordUpdateModal = (): void => {
    setUpdatePasswordActive(true);
  };

  const closePasswordUpdateModal = (): void => {
    setUpdatePasswordActive(false);
    setValidateError(false);
    setValidityMessages({
      password: {
        tooShort: 'Must be at least 8 characters.',
        patternMismatch:
          'Must contain at least 8 characters including an uppercase letter, lowercase letter, and a number or special character..',
      },
    });
  };

  const updatePassword = async (oldPass: string, newPass: string): Promise<void> => {
    const bodyPayload = {
      user: {
        email: props.email,
      },
      passwordObject: {
        oldPassword: oldPass,
        password: newPass,
      },
    };
    const res = await updateUsersPassword(bodyPayload);
    if (res.error) {
      handleSetValidateError(true);
      throw new Error(res.message);
    }
  };
  const openAvatarModal = () => {
    setImageModalOpen(true);
  };
  const closeAvatarModal = () => {
    setImageModalOpen(false);
  };
  // *** END OF FUNCTIONS ***
  // *** FETCH FUNCTIONS ***
  const handleFetchUser = async () => {
    if (props.accountId) {
      const userPayload = {
        accountId: props.accountId,
      };
      const userRes = await getUser(userPayload);
      const currentUser = userRes?.user && typeof userRes.user === 'object' ? userRes.user : userRes;

      if (userRes) {
        setReceiveEmails(currentUser?.emailNotifications || false);
        setForm({
          firstName: currentUser?.firstName || props.firstName || '',
          lastName: currentUser?.lastName || props.lastName || '',
          email: currentUser?.email || props.email || '',
          label: currentUser?.label || '',
        });
      }
    }
  };
  // *** END OF FETCH FUNCTIONS ***
  // *** USE EFFECTS ***
  useEffect(() => {
    trackView(MixpanelEvents.USER_SETTINGS, {});
  }, []);

  useEffect(()=>{
    handleFetchUser();
  },[props.accountId])

  useEffect(() => {
    if (props.logoId !== logoId) {
      setLogoId(props.logoId);
    }
  }, []);

  useEffect(() => {
    setReceiveEmails(props?.accountUser?.emailNotifications || false);
    setForm({
      firstName: props?.accountUser?.firstName || props.firstName || '',
      lastName: props?.accountUser?.lastName || props.lastName || '',
      email: props?.accountUser?.email || props.email || '',
      label: props?.accountUser?.label || '',
    });
  }, [props.accountUser]);
  // *** END OF USE EFFECTS ***
  // *** CONSTS ***

  // *** END OF CONSTS ***
  // RENDER
  return (
    <div className="m-[20px] flex flex-1 flex-col">
      <div className="max-w-4xl space-y-6">
        <h1 className="text-[24px] font-medium text-foreground m-0">User Settings</h1>

        <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
          <h3 className="text-[16px] font-medium text-foreground m-0">Profile Image</h3>

          <div className="flex md:flex-row flex-col md:items-center items-start gap-4">
            <div className="shrink-0 overflow-hidden rounded-full h-20 w-20 border-2 border-border bg-background">
              {logoId ? (
                <img
                  className="aspect-square h-full w-full"
                  src={`${Config.fileStoreUrl}${logoId}`}
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center rounded-full bg-background">
                  <UserIcon className="lucide lucide-user-round h-10 w-10 text-muted-foreground" />
                </div>
              )}
            </div>

            <div className="flex gap-2">
              <Button
                data-qa={`user_settings_choose_image_trigger`}
                className="py-0 inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:border-input-hover h-9 rounded-md px-3"
                type="button"
                variant={'outline'}
                onClick={openAvatarModal}
              >
                {!logoId ? <UploadIcon className="lucide lucide-upload h-4 w-4 mr-2" /> : null}
                {logoId ? 'Replace Image' : 'Upload'}
              </Button>

              {logoId && (
                <Button
                  data-qa={`user_settings_delete_image_trigger`}
                  onClick={deleteAvatarImage}
                  className="bg-transparent p-0 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 hover:bg-accent h-8 w-8 text-muted-foreground hover:text-destructive"
                  type="button"
                >
                  <Trash2Icon className="w-[16px] h-[16px]" />
                </Button>
              )}
            </div>
          </div>
        </div>

        <div className="space-y-4 p-4 bg-muted/50 rounded-lg">
          <h3 className="text-[16px] font-medium text-foreground">Account Information</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label
                htmlFor="first_name"
                className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium"
              >
                First Name
                <span className="text-destructive">*</span>
              </Label>
              <div ref={firstNameRef} className="relative w-full">
                <Input
                  data-qa={`user_settings_first_name_input`}
                  id="first_name"
                  name="firstName"
                  value={form.firstName}
                  onChange={(e) => handleChangeForm(e)}
                  onBlur={(e) => handleValidateFormOnBlur(e)}
                  className={`${formError?.firstName?.active ? 'bg-[#FCF0F0] border-[#EE9797]' : ''}`}
                />
                {/* TODO: make better popup error */}
                <ErrorInputPopUp
                  anchorRef={firstNameRef}
                  active={formError?.firstName?.active}
                  message={formError?.firstName?.message}
                  position="bottom-end"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label
                htmlFor="last_name"
                className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium"
              >
                Last Name
                <span className="text-destructive">*</span>
              </Label>
              <div ref={lastNameRef} className="relative w-full">
                <Input
                  data-qa={`user_settings_last_name_input`}
                  id="last_name"
                  name="lastName"
                  value={form.lastName}
                  onChange={(e) => handleChangeForm(e)}
                  onBlur={(e) => handleValidateFormOnBlur(e)}
                  className={`${formError?.lastName?.active ? 'bg-[#FCF0F0] border-[#EE9797]' : ''}`}
                />
                {/* TODO: make better popup error */}
                <ErrorInputPopUp
                  anchorRef={lastNameRef}
                  active={formError?.lastName?.active}
                  message={formError?.lastName?.message}
                  position="bottom-end"
                />
              </div>
            </div>
          </div>

          {props?.canAccessTeamSettings && (
            <div className="space-y-2">
              <Label
                htmlFor="label"
                className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium"
              >
                Label
                <span className="text-destructive">*</span>
              </Label>

              <div className="flex items-center gap-1 max-w-sm">
                <span className="text-sm text-muted-foreground">@</span>
                <div ref={labelRef} className="relative w-full">
                  <Input
                    data-qa={`user_settings_label_input`}
                    id="label"
                    name="label"
                    value={form.label}
                    onChange={(e) => handleChangeForm(e)}
                    onBlur={(e) => handleValidateFormOnBlur(e)}
                    className={`${formError?.label?.active ? 'bg-[#FCF0F0] border-[#EE9797]' : ''}`}
                  />
                  {/* TODO: make better popup error */}
                  <ErrorInputPopUp
                    anchorRef={labelRef}
                    active={formError?.label?.active}
                    message={formError?.label?.message}
                    position="bottom-end"
                  />
                </div>
              </div>

              <p className="text-xs text-muted-foreground">
                Used for mentions and assignments in team collaboration.
              </p>
            </div>
          )}

          <div className="space-y-2">
            <Label
              htmlFor="e_mail"
              className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium"
            >
              E-mail
              <span className="text-destructive">*</span>
            </Label>

            <div ref={emailRef} className="relative max-w-sm">
              <Input
                data-qa={`user_settings_email_input`}
                id="e_mail"
                name="email"
                value={form.email}
                onChange={(e) => handleChangeForm(e)}
                onBlur={(e) => handleValidateFormOnBlur(e)}
                className={`${formError?.email?.active ? 'bg-[#FCF0F0] border-[#EE9797]' : ''}`}
              />
              {/* TODO: make better popup error */}
              <ErrorInputPopUp
                anchorRef={emailRef}
                active={formError?.email?.active}
                message={formError?.email?.message}
                position="bottom-end"
              />
            </div>
          </div>

          {/* -------------------------------------------- */}
          {props?.canAccessTeamSettings && (
            <div className="flex items-center space-x-3 max-w-sm">
              <Switch
                checked={receiveEmails}
                onClick={() => handleReceiveEmails()}
                disabled={false}
                aria-label="Toggle want to receive email notifications"
                data-qa={'receiving_emails_switcher'}
                id="switch_receiving_email"
              />
              <Label
                htmlFor="switch_receiving_email"
                className="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium cursor-pointer"
              >
                I want to receive email notifications
              </Label>
            </div>
          )}
          {/* -------------------------------------------- */}

          <div className="flex md:flex-row md:justify-end gap-2 pt-4 flex-col">
            <Button
              data-qa={`user_settings_update_password_trigger`}
              onClick={openPasswordUpdateModal}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 underline-offset-4 hover:underline h-10 px-4 py-2 text-muted-foreground hover:text-foreground"
              type="button"
              variant={'link'}
            >
              Update Password
            </Button>
            <Button
              data-qa={`user_settings_update_information_trigger`}
              onClick={submit}
              type="button"
            >
              Update Information
            </Button>
          </div>
        </div>
      </div>

      <AvatarModal
        uiActive={imageModalOpen}
        uiOnRequestClose={closeAvatarModal}
        onSave={saveAvatarImage}
      />

      <PageDimmer uiActive={updatePasswordActive} />
      <UpdatePasswordModal
        active={updatePasswordActive}
        onRequestClose={closePasswordUpdateModal}
        onUpdatePassword={updatePassword}
        validityMessages={validityMessages}
        validityMessageOldPass={validityMessageOldPass}
        handleSetValidationMessageOldPass={handleSetValidationMessageOldPass}
        handleSetValidationMessage={handleSetValidationMessage}
        validateError={validateError}
        handleSetValidateError={handleSetValidateError}
      />
    </div>
  );
};

// export class UserSettings extends PureComponent<UserSettingsProps & DispatchProp, State> {
//   public state: State = {
//     updatePasswordActive: false,
//     imageModalOpen: false,
//     logoId: this.props.logoId,
//     validateError: false,
//     validityMessages: {
//       password: {
//         tooShort: 'Must be at least 8 characters.',
//         patternMismatch:
//           'Must contain at least 8 characters including an uppercase letter, lowercase letter, and a number or special character..',
//       },
//     },
//     validityMessageOldPass: {
//       password: {
//         tooShort: 'Must be at least 8 characters.',
//         patternMismatch:
//           'Must contain at least 8 characters including an uppercase letter, lowercase letter, and a number or special character..',
//       },
//     },
//   };

//   private validationMessages: ValidityMessagesMap<'username' | 'email'> = {
//     username: {
//       nonUnique: 'An account with that Username already exists',
//       patternMismatch: 'Only alphanum characters are allowed',
//     },
//     email: {
//       nonUnique: 'An account with that Email already exists',
//     },
//   };

//   componentDidMount(): void {
//     // Track View with Mixpanel
//     trackView(MixpanelEvents.USER_SETTINGS, {});
//     // End of code for Track View with Mixpanel
//   }

//   componentDidUpdate(prevProps: UserSettingsProps) {
//     if (prevProps.logoId !== this.props.logoId) {
//       this.setState({ logoId: this.props.logoId });
//     }
//   }

//   private handleSetValidationMessage = (value: string): void => {
//     this.setState((prev) => {
//       return {
//         ...prev,
//         validityMessages: {
//           password: {
//             patternMismatch: value,
//           },
//         },
//       };
//     });
//   };
//   private handleSetValidationMessageOldPass = (value: string): void => {
//     this.setState((prev) => {
//       return {
//         ...prev,
//         validityMessageOldPass: {
//           password: {
//             patternMismatch: value,
//           },
//         },
//       };
//     });
//   };

//   private handleSetValidateError = (val: boolean): void => {
//     this.setState((prev) => {
//       return {
//         ...prev,
//         validateError: val,
//       };
//     });
//   };

//   private deleteAvatarImage = async () => {
//     const { accountId } = this.props;
//     const user = localStorage.getItem('quipa-store');
//     const email = user ? JSON.parse(user).user.email : '';
//     const userUpdatePayload = {
//       accountId,
//       firstName: this.props.firstName,
//       lastName: this.props.lastName,
//       user: { email },
//       logoId: null,
//       email,
//     };
//     const res = await handleUpdateUser(userUpdatePayload);

//     if (res.error) {
//       if (res.payload.name === 'ValidationError') {
//         const errors = (res.payload as Error as ValidationError).errors;
//         throw FormValidationError.fromErrorDictionary(errors);
//       } else {
//         throw new Error(res.payload.message);
//       }
//     } else {
//       localStorage.removeItem('logoId');

//       window.location.reload();
//     }
//   };
//   private saveAvatarImage = async (file: File) => {
//     const { accountId } = this.props;
//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('accountId', accountId.toString());
//     formData.append('fileStoreUrl', Config.fileStoreUrl);
//     const res = await uploadImage(formData);

//     if (res.error) {
//       throw new Error(res.message);
//     }
//     const user = localStorage.getItem('quipa-store');
//     const email = user ? JSON.parse(user).user.email : '';

//     const userUpdatePayload = {
//       accountId,
//       logoId: res.url,
//       user: { email },
//     };

//     const res1 = await handleUpdateUser(userUpdatePayload);

//     if (res1.error) {
//       if (res1.name === 'ValidationError') {
//         const errors = (res1 as Error as ValidationError).errors;
//         throw FormValidationError.fromErrorDictionary(errors);
//       } else {
//         throw new Error(res1.message);
//       }
//     } else {
//       this.setState({
//         logoId: res.url,
//         imageModalOpen: false,
//       });
//       localStorage.setItem('logoId', res.url || '');

//       window.location.reload();
//     }
//   };
//   public render(): JSX.Element {
//     const { email, firstName, lastName } = this.props;
//     return (
//       <PageContent>
//         <PageHeader classNameProps="font-24 mt-0" title="User Settings" />
//         <ContentSection style={{ display: 'flex', alignItems: 'flex-start' }}>
//           <VContainer
//             uiFlex="1"
//             uiMinWidth="225px"
//             style={{ marginLeft: '10px', paddingRight: '37px' }}
//           >
//             <VSpace uiHeight="20px" />
//             <div
//               style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 borderBottom: '1px solid #E2E2E2',
//                 width: '100%',
//               }}
//             >
//               <div
//                 style={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                 }}
//               >
//                 <FormSubtitle>PROFILE IMAGE</FormSubtitle>
//                 <div
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                   }}
//                 >
//                   <div onClick={this.openAvatarModal}>
//                     <PencilEdit />
//                   </div>
//                   {this.state.logoId && (
//                     <>
//                       <GrayBorder />
//                       <div
//                         style={{
//                           display: 'flex',
//                           alignItems: 'center',
//                         }}
//                         onClick={this.deleteAvatarImage}
//                       >
//                         <TrashDelete />
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <AvatarContainer>
//               <UserAvatar
//                 avatarId={this.state.logoId}
//                 openAvatarModal={this.openAvatarModal}
//                 deleteAvatarImage={this.deleteAvatarImage}
//                 isSquareImgHolder={true}
//               />
//               <AvatarActionContainer></AvatarActionContainer>
//             </AvatarContainer>
//             <AvatarModal
//               uiActive={this.state.imageModalOpen}
//               uiOnRequestClose={this.closeAvatarModal}
//               onSave={this.saveAvatarImage}
//             />
//           </VContainer>
//           <div
//             style={{
//               flex: '2',
//               display: 'flex',
//               alignItems: 'center',
//               borderLeft: '1px solid #3b97b1',
//               paddingLeft: '37px',
//             }}
//           >
//             {' '}
//             <UserForm
//               uiPadding={false}
//               uiSubmitFailedIcon
//               uiReportValidityMode="firstInvalid"
//               uiOnSubmit={this.submit}
//               uiDimmerBlurring={false}
//             >
//               <FormField uiRequired uiLabel="E-Mail" uiLabelFor="email">
//                 <ValidationPopupStateInput
//                   id="email"
//                   name="email"
//                   type="email"
//                   required
//                   tabIndex={2}
//                   maxLength={255}
//                   pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
//                   defaultValue={email}
//                   uiCustomAsyncValidator={this.uniquenessValidator}
//                   uiValidityMessages={this.validationMessages.email}
//                   uiReportAsyncValidationPending
//                   uiReportResultTimeout={3000}
//                   uiPopupPosition="bottom right"
//                 />
//               </FormField>
//               <FormField uiRequired uiLabel="First Name" uiLabelFor="firstname">
//                 <ValidationPopupInput
//                   id="firstname"
//                   name="firstname"
//                   required
//                   tabIndex={3}
//                   maxLength={255}
//                   defaultValue={firstName}
//                   uiPopupPosition="bottom right"
//                 />
//               </FormField>
//               <FormField uiRequired uiLabel="Last Name" uiLabelFor="lastname">
//                 <ValidationPopupInput
//                   id="lastname"
//                   name="lastname"
//                   required
//                   tabIndex={3}
//                   maxLength={255}
//                   defaultValue={lastName}
//                   uiPopupPosition="bottom right"
//                 />
//               </FormField>
//               <Button type="submit" uiColor="primary">
//                 Update
//               </Button>
//               <UpdatePasswordButton
//                 type="button"
//                 uiColor="secondary"
//                 onClick={this.openPasswordUpdateModal}
//               >
//                 Update Password
//               </UpdatePasswordButton>
//             </UserForm>
//           </div>
//         </ContentSection>
//         <PageDimmer uiActive={this.state.updatePasswordActive} />
//         <UpdatePasswordModal
//           active={this.state.updatePasswordActive}
//           onRequestClose={this.closePasswordUpdateModal}
//           onUpdatePassword={this.updatePassword}
//           validityMessages={this.state.validityMessages}
//           validityMessageOldPass={this.state.validityMessageOldPass}
//           handleSetValidationMessageOldPass={this.handleSetValidationMessageOldPass}
//           handleSetValidationMessage={this.handleSetValidationMessage}
//           validateError={this.state.validateError}
//           handleSetValidateError={this.handleSetValidateError}
//         />
//       </PageContent>
//     );
//   }

//   @Bind()
//   private async uniquenessValidator(
//     val: string,
//     elem: HTMLInputElement
//   ): Promise<{ [key: string]: boolean } | undefined> {
//     const { email } = this.props;
//     val = val.trim();
//     if (elem.id === 'email' && email !== val) {
//       const res = await validateEmail(val.trim());
//       if (res.error) {
//         return {
//           nonUnique: true,
//         };
//       }
//     }
//   }

//   @Bind()
//   private async submit(e: FormEvent<HTMLFormElement>): Promise<void> {
//     const { dispatch, firstName, lastName, accountId } = this.props;
//     const user = localStorage.getItem('quipa-store');
//     const email = user ? JSON.parse(user).user.email : '';
//     /* tslint:disable:no-string-literal */
//     const newEmail = (e.currentTarget.elements['email'] as HTMLInputElement).value.trim();
//     const newFirstName = (e.currentTarget.elements['firstname'] as HTMLInputElement).value.trim();
//     const newLastName = (e.currentTarget.elements['lastname'] as HTMLInputElement).value.trim();
//     const userSettingsPayload = {
//       email: email !== newEmail ? newEmail : undefined,
//       firstName: firstName !== newFirstName ? newFirstName : undefined,
//       lastName: lastName !== newLastName ? newLastName : undefined,
//     };

//     const body = {
//       ...userSettingsPayload,
//       user: {
//         email,
//       },
//       email: newEmail ? newEmail : email,
//     };
//     const res = await handleUpdateUser(body);

//     if (res && !res.email) {
//       const user = localStorage.getItem('quipa-store');
//       const token = user ? JSON.parse(user).user.token : '';

//       let objectLocal: any = {
//         user: { email: newEmail ? newEmail : email, token },
//       };
//       objectLocal = JSON.stringify(objectLocal);
//       localStorage.setItem('quipa-store', objectLocal as string);
//       localStorage.setItem('firstName', newFirstName);
//       localStorage.setItem('lastName', newLastName);
//     }

//     const accountPayload = {
//       email: email !== newEmail ? newEmail : email,
//       firstName: firstName !== newFirstName ? newFirstName : firstName,
//       lastName: lastName !== newLastName ? newLastName : lastName,
//       prevEmail: email,
//     };
//     if (res.error) {
//       console.log('error:', res.payload.message);
//       return;
//     }
//     const responseCrisp = await updateCrispEmail(accountId, accountPayload);
//     if (responseCrisp.status === 200) {
//       const notification: NotificationsModule.Notification = {
//         id: 0,
//         message: 'Success!',
//         subMessage: 'User settings updated.',
//         type: 'info',
//       };
//       dispatch(NotificationsModule.addNotification(notification));
//       const profile = await getCrispProfile(accountId);
//       if (profile) {
//         Crisp.user.setEmail(profile.email);
//         Crisp.user.setNickname(`${profile.person.nickname}`);
//       }
//     }
//     window.location.reload();
//   }

//   @Bind()
//   private openPasswordUpdateModal(): void {
//     this.setState({
//       updatePasswordActive: true,
//     });
//   }

//   @Bind()
//   private closePasswordUpdateModal(): void {
//     this.setState((prev) => {
//       return {
//         ...prev,
//         updatePasswordActive: false,
//         validateError: false,
//         validityMessages: {
//           password: {
//             tooShort: 'Must be at least 8 characters.',
//             patternMismatch:
//               'Must contain at least 8 characters including an uppercase letter, lowercase letter, and a number or special character..',
//           },
//         },
//       };
//     });
//   }

//   @Bind()
//   private async updatePassword(oldPass: string, newPass: string): Promise<void> {
//     const bodyPayload = {
//       user: {
//         email: this.props.email,
//       },
//       passwordObject: {
//         oldPassword: oldPass,
//         password: newPass,
//       },
//     };
//     const res = await updateUsersPassword(bodyPayload);
//     if (res.error) {
//       this.handleSetValidateError(true);
//       throw new Error(res.message);
//     }
//   }
//   private openAvatarModal = () => {
//     this.setState({
//       imageModalOpen: true,
//     });
//   };
//   private closeAvatarModal = () => {
//     this.setState({
//       imageModalOpen: false,
//     });
//   };
// }

function mapStateToProps(state: RootState): UserSettingsProps {
  const user = localStorage.getItem('quipa-store');
  const email = user ? JSON.parse(user).user.email : '';
  return {
    email: email,
    firstName: localStorage.getItem('firstName') || '',
    lastName: localStorage.getItem('lastName') || '',
    accountId: parseFloat(localStorage.getItem('accountId') || '0'),
    logoId: localStorage.getItem('logoId') || null,
  };
}

export const UserSettingsContainer = connect(mapStateToProps)(UserSettingsPage);
